module.exports = __webpack_public_path__ + "media/images/2023/opening-banner-02df034c31af1a8041bc8491f673b55d.jpg";